import React, { Component } from "react";
import axios from "axios";
import {
  emailRegex,
  encrypt,
  allRegex
} from '../../../shared/helper.js'
import { Loader } from "../../common/loader/loader.jsx";
import {
  baseURL,
} from "../../../constants/applicationConstants.js";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from './login.jsx'

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        email: "",
        password: "",
      },
      isProcessing: false,
      formError: {},
      formSubmitButtonDisable: true,
      isLoading: false
    };
  }
  componentDidMount = () => {
    let isLogin = localStorage.getItem('isLoggedIn') && localStorage.getItem('isLoggedIn');
    if (isLogin && isLogin) {
      this.props.history.push("/dashboard");
    } else {
      this.props.history.push("/admin/opsLoginPass");

    }
  }

  onInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value) {
      if (!this.inputRegexValidation(name, value)) {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "regx",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      } else {
        this.setState(
          {
            formData: {
              ...this.state.formData,
              [name]: value,
            },
            formError: {
              ...this.state.formError,
              [name]: "",
            },
          },
          () => this.isFromSubmissionBlock()
        );
      }
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            [name]: value,
          },
          formError: {
            ...this.state.formError,
            [name]: "",
          },
        },
        () => this.isFromSubmissionBlock()
      );
    }
  };
  // encrypt = () => {
  //   let ciphertext = CryptoJS.AES.encrypt('$C$pYuM#QM0f', 'vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3').toString();
  // }
  // decrypt = () => {
  //   let bytes = CryptoJS.AES.decrypt("U2FsdGVkX1+axK93BX1ZQ+AR8bXDqjtELPE7D6aJXwI=", 'vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3325');
  //   let originalText = bytes.toString(CryptoJS.enc.Utf8);
  // }


  onTouchHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value === "") {
      this.setState({
        formError: {
          ...this.state.formError,
          [name]: "req",
        },
      });
    } else {
      if (!this.inputRegexValidation(name, value)) {
        this.setState({
          formError: {
            ...this.state.formError,
            [name]: "regx",
          },
        });
      }
    }
  };

  inputRegexValidation = (name, value) => {

    if (name === "email") {
      return emailRegex.test(value);
    }
    else {
      return allRegex.test(value)
    }
  };

  isFromSubmissionBlock = () => {
    let { password } = this.state.formData;
    if (password) {
      if (

        !this.inputRegexValidation("password", password)
      ) {
        this.setState({
          formSubmitButtonDisable: true,
        });
      } else {
        this.setState({
          formSubmitButtonDisable: false,
        });
      }
    } else {
      this.setState({
        formSubmitButtonDisable: true,
      });
    }
  };
  formSubmitHandler = (e) => {
    this.setState({
      isLoading: true
    })
    e.preventDefault();
    let data = {
      email: this.state.formData.email,
      password: encrypt(this.state.formData.password)
      // password: this.state.formData.password

    };
    axios.post(`${baseURL}/institute/login`, data).then((res) => {
      localStorage.setItem("auth", JSON.stringify(res?.data?.data));
      localStorage.setItem("token", JSON.stringify(res.data?.data?.accessToken));
      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("masterID", JSON.stringify(res.data?.data?.instituteId));
      localStorage.setItem("loginData", JSON.stringify(res.data?.data));
      localStorage.setItem('flowName', 'institute')
      localStorage.setItem('flowType', 'institute')
      this.setState({
        isLoading: false
      })
      // swal({
      //   title: "success",
      //   text: "You have logged-in successfully",
      //   icon: "success",
      //   successMode: true,
      // }).then(res => {
      //     if (res) {
      //       this.props.history.push("/dashboard");
      //     }
      // });
      toast.success("You have logged-in successfully");
      setTimeout(() => {
        this.props.history.push("/dashboard");
        window.location.reload()
      }, 2000)

    }).catch((res) => {
      toast.error(res?.response.data.error.message);
      this.setState({
        isLoading: false
      })
    })

  };



  render() {
    return (
      <div>
        <LoginPage
          formData={this.state.formData}
          onInputChangeHandler={this.onInputChangeHandler}
          onTouchHandler={this.onTouchHandler}
          formSubmitButtonDisable={this.state.formSubmitButtonDisable}
          formError={this.state.formError}
          formSubmitHandler={this.formSubmitHandler}
          isLoading={this.state.isLoading}
        // encrypt={this.encrypt}
        // decrypt={this.decrypt}
        // isProcessing={this.state.isProcessing}
        />
        {this.state.isLoading && <Loader />}
      </div>
    );
  }
}

export default Login;
